import { useEffect, useState } from 'react';
import { userService } from '../../../data/services/userService';

/**
 * Custom hook for managing user profile data
 */
export function useUserProfile() {
    const [user, setUser] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchUserProfile = async () => {
        try {
            setIsLoading(true);
            setError(null);
            const userData = JSON.parse(localStorage.getItem('waiver') || '{}')['data'];
            setUser(userData);
        } catch (err) {
            setError(err.message || 'Failed to fetch user profile');
            console.error('Error fetching user profile:', err);
        } finally {
            setIsLoading(false);
        }
    };

    const updateUserProfile = async (userData) => {
        try {
            setIsLoading(true);
            setError(null);
            const updatedUser = await userService.updateUserProfile(userData);
            setUser(updatedUser);
            return updatedUser;
        } catch (err) {
            setError(err.message || 'Failed to update user profile');
            throw err;
        } finally {
            setIsLoading(false);
        }
    };

    const uploadAvatar = async (file) => {
        try {
            setIsLoading(true);
            setError(null);
            const avatarUrl = await userService.uploadAvatar(file);
            setUser((prev) => ({ ...prev, avatar: avatarUrl }));
            return avatarUrl;
        } catch (err) {
            setError(err.message || 'Failed to upload avatar');
            throw err;
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchUserProfile();
    }, []);

    return {
        user,
        isLoading,
        error,
        refetch: fetchUserProfile,
        updateProfile: updateUserProfile,
        uploadAvatar,
    };
}
